import React from 'react';
import { Box, Typography } from '../../../../base';
import { useTranslation } from 'react-i18next';

const NoChatMessages = () => {
    const { t } = useTranslation();

    return (
        <Box sx={{ p: 2, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
                {t('jobApplicationPage.noChatMessages')}
            </Typography>
        </Box>
    );
};

export default NoChatMessages;
